import { URI } from '@fiverr-private/futile';
import imageMapper from '../tiles/sc_tile/imageMapper';

export const getScFilterUrl = (scItem) => window && window.location ? new URI(window.location.href).addParams({
    'sub_category': scItem.params.sub_category
}).href : '';

export const getScTilesData = (significantLeafCategories, subCategory) => {
    const scTiles = [];
    significantLeafCategories.forEach((significantSc) => {
        const scItem = subCategory.children.find((sc) => sc.params.sub_category === significantSc);
        if (scItem) {
            const url = getScFilterUrl(scItem);
            const id = scItem.params.sub_category;
            const src = imageMapper[id];
            src && scTiles.push({ id, alias: scItem.alias, url, src, count: scItem.count });
        }
    });

    return scTiles;
};
